<template>
  <div class="device_container">
    <MessageTop class="device_message_top" />

    <div class="device">
      <!-- 虚拟键盘选键提示 (Simplified V2) -->
      <SelectionGuide :visible="showSelectionGuide" />
      <Decorate v-if="isShowDecorate" />
      <Device_set v-else />
    </div>

    <MessageBottom class="device_message_bottom" />
  </div>
</template>

<script setup lang="ts">
import Device_set from './device_set.vue'
import MessageTop from '../message/message_top.vue'
import MessageBottom from '../message/message_bottom.vue'
import { computed, ref, watch } from 'vue'
import { operate, OperateType } from '@/service/driver/operate'
import Decorate from './decorate.vue'
import { lightSet } from '@/service/driver/light_set'
import { LightModeType } from '@/define/light'
import { magnetSet } from '@/service/driver/magnet_set'
import SelectionGuide from './selection_guide.vue'

const showSelectionGuide = ref(false)

// 监听磁轴设置的引导标志位
watch(
  () => (magnetSet as any)._showGuideFlag?.value,
  (val) => {
    if (val) {
      showSelectionGuide.value = true
      setTimeout(() => {
        showSelectionGuide.value = false
        if ((magnetSet as any)._showGuideFlag) (magnetSet as any)._showGuideFlag.value = false
      }, 2000)
    }
  },
)

// 实时监听选键状态：一旦用户选中了按键（单击或框选），立即隐藏引导动画
watch(
  () => magnetSet.selectedKeys.value.length,
  (newCount) => {
    if (newCount > 0 && showSelectionGuide.value) {
      showSelectionGuide.value = false
      // 同时重置 Service 里的标志位，防止逻辑残留
      if ((magnetSet as any)._showGuideFlag) (magnetSet as any)._showGuideFlag.value = false
    }
  },
)

const isShowDecorate = computed(() => {
  return lightSet.currentModeTypeTab.value == LightModeType.Side && lightSet.modeName.includes('自定义')
})

watch(operate.getActionType(), (_type: OperateType) => {
  // 如果切换出触发设置页面，立即强制隐藏引导动画
  if (_type !== OperateType.mgx) {
    showSelectionGuide.value = false
    if ((magnetSet as any)._showGuideFlag) (magnetSet as any)._showGuideFlag.value = false
  }
})
</script>

<style lang="less">
.device_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
  position: relative;
  padding: 8px 0;
  gap: 12px;
  overflow: visible;

  .device_message_top,
  .device_message_bottom {
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 300;
    pointer-events: none;
  }

  .device_message_top {
    top: 0;
  }

  .device_message_bottom {
    bottom: 0;
  }

  .device {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: max-content;
    max-width: 100%;
    flex: 0 1 auto;
    position: relative;
  }

  .device_power {
    position: absolute;
    top: 0;
    right: -70px;
  }

  .device > * {
    max-width: 100%;
  }
}

/* 引入共用的 fade-slide 动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s var(--transition-base);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translate(0, 20px);
}
</style>
